import script from "./BrandAuthOperators.vue?vue&type=script&lang=ts&setup=true"
export * from "./BrandAuthOperators.vue?vue&type=script&lang=ts&setup=true"

import "./BrandAuthOperators.vue?vue&type=style&index=0&id=128fcec8&lang=scss"

const __exports__ = script;

export default __exports__